import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=24dc9c47&scoped=true&"
import script from "./IconLink.vue?vue&type=script&lang=ts&"
export * from "./IconLink.vue?vue&type=script&lang=ts&"
import style0 from "./IconLink.vue?vue&type=style&index=0&id=24dc9c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc9c47",
  null
  
)

export default component.exports